<template>
  <div class="bg-gray-50 py-8">
    <UiNarrowContainer>
      <div class="flex flex-col items-center md:flex-row">
        <div class="mb-8 w-full space-y-4 md:mb-0 md:w-1/2">
          <UiSkeleton class="h-10 w-3/4" />
          <UiSkeleton class="h-6 w-4/5" />
          <UiSkeleton class="h-4 w-2/3" />
          <div class="pt-4">
            <UiSkeleton class="h-12 w-48 rounded-full" />
          </div>
        </div>
        <div class="w-full md:w-1/2">
          <UiSkeleton class="h-64 w-full rounded-xl md:h-80" />
        </div>
      </div>
    </UiNarrowContainer>
  </div>

  <UiNarrowContainer class="py-10">
    <UiSkeleton class="mb-8 h-8 w-48" />
    <div class="grid grid-cols-2 gap-4 md:grid-cols-6">
      <div v-for="i in 6" :key="i" class="flex flex-col items-center">
        <UiSkeleton class="mb-2 h-36 w-full rounded-md" />
        <UiSkeleton class="mb-1 h-4 w-24" />
        <UiSkeleton class="h-3 w-16" />
      </div>
    </div>
  </UiNarrowContainer>

  <UiNarrowContainer class="py-10">
    <UiSkeleton class="mb-2 h-5 w-32" />
    <UiSkeleton class="mb-8 h-8 w-48" />
    <div class="relative">
      <div class="flex space-x-6 overflow-hidden">
        <div v-for="i in 4" :key="i" class="min-w-[250px] shrink-0">
          <UiSkeleton class="mb-3 h-72 w-full rounded-md" />
          <UiSkeleton class="mb-2 h-5 w-3/4" />
          <UiSkeleton class="h-6 w-16" />
        </div>
      </div>
      <div class="absolute -left-4 top-1/3">
        <UiSkeleton class="size-10 rounded-full" />
      </div>
      <div class="absolute -right-4 top-1/3">
        <UiSkeleton class="size-10 rounded-full" />
      </div>
    </div>
  </UiNarrowContainer>

  <div class="mt-8 bg-gray-50 py-12">
    <UiNarrowContainer class="text-center">
      <UiSkeleton class="mx-auto mb-2 h-5 w-40" />
      <UiSkeleton class="mx-auto mb-8 h-8 w-72" />
      <div class="mb-8 flex justify-center space-x-4">
        <div v-for="i in 4" :key="i" class="flex flex-col items-center">
          <UiSkeleton class="mb-2 size-16 rounded" />
          <UiSkeleton class="h-4 w-12" />
        </div>
      </div>
      <UiSkeleton class="mx-auto h-12 w-32 rounded-full" />
    </UiNarrowContainer>
  </div>

  <UiNarrowContainer class="py-16">
    <UiSkeleton class="mx-auto mb-6 h-6 w-40" />
    <UiSkeleton class="mx-auto mb-10 h-8 w-64" />
    <div class="flex items-start space-x-6">
      <UiSkeleton class="size-16 shrink-0 rounded-full" />
      <div class="flex-1 space-y-3">
        <div class="mb-2 flex">
          <UiSkeleton class="h-4 w-24" />
        </div>
        <UiSkeleton class="h-4 w-full" />
        <UiSkeleton class="h-4 w-full" />
        <UiSkeleton class="h-4 w-3/4" />
        <div class="pt-3">
          <UiSkeleton class="h-5 w-32" />
          <UiSkeleton class="mt-1 h-4 w-24" />
        </div>
      </div>
    </div>
  </UiNarrowContainer>
</template>
